import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Formik } from 'formik';
import { withRouter } from 'react-router-dom';
import { Mutation, withApollo } from 'react-apollo';
import LotModalForm from '~/components/lotModalForm/lotModalForm';
import { lotValidationSchema } from '~/validation/lot';

export const createLotMutation = gql`
  mutation createLot(
    $breweryId: Int!
    $productId: Int!
    $transferScheduleId: Int!
    $volume: Int!
    $isSample: Boolean!
    $startDate: String!
    $notes: String
  ) {
    createLot(
      breweryId: $breweryId
      productId: $productId
      volume: $volume
      isSample: $isSample
      transferScheduleId: $transferScheduleId
      startDate: $startDate
      notes: $notes
    ) {
      id
      reference
      startDate
    }
  }
`;

const LotCreateSingle = ({ brewery, defaultLotVolume, isOpen, onToggle, client, history }) => (
  <Modal isOpen={isOpen} toggle={onToggle}>
    <Mutation mutation={createLotMutation}>
      {createLot => (
        <Fragment>
          <ModalHeader toggle={onToggle}>Schedule a new lot</ModalHeader>
          <Formik
            initialValues={{
              isSample: false,
              volume: defaultLotVolume
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={lotValidationSchema}
            onSubmit={async (values, { setErrors, setSubmitting }) => {
              try {
                const newLot = await createLot({
                  variables: {
                    ...values,
                    breweryId: brewery.id
                  },
                  awaitRefetchQueries: true,
                  refetchQueries: ['lots']
                });
                history.push(`/lots?new=${newLot.data.createLot.reference}`);
                onToggle();
              } catch (err) {
                setErrors({
                  unknown: 'An unknown error occured'
                });
                setSubmitting(false);
              }
            }}
            render={props => <LotModalForm {...props} onCancelClick={onToggle} />}
          />
        </Fragment>
      )}
    </Mutation>
  </Modal>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery,
    defaultLotVolume: state.brewery.settings.defaultLotVolume
  };
}

export default connect(mapStateToProps)(withRouter(withApollo(LotCreateSingle)));



// WEBPACK FOOTER //
// ./src/containers/lotCreate/createSingle.jsx